const getHostSubdomain = () => {
  const host = window.location.host;
  
    let hostSubdomain;
    if (host.startsWith('www.')) {
        const parts = host.split('.');
        hostSubdomain = parts.length > 2 ? parts[1] : parts[0];
    } else {
        hostSubdomain = host.split(".")[0];
    }
    
    // const hostSubdomain = 'exclusive';

    const hostFinalSubdomain = hostSubdomain !== 'caready' && !hostSubdomain.includes('localhost') && hostSubdomain !== 'staging' ? hostSubdomain : 'global'
    return hostFinalSubdomain
}

export default getHostSubdomain